import React from 'react';
import { Box, Typography, Button, Container, Grid, Paper } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';

const MarketplaceHero: React.FC = () => {
  return (
    <Paper
      sx={{
        position: 'relative',
        backgroundColor: 'grey.800',
        color: '#fff',
        mb: 4,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: 'url(https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80)',
        borderRadius: 4,
        overflow: 'hidden',
        minHeight: { xs: 300, md: 400 },
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {/* Increase the priority of the hero background image */}
      {<img style={{ display: 'none' }} src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80" alt="hero background" />}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: 'rgba(0,0,0,.4)',
        }}
      />
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid container>
          <Grid item md={6}>
            <Box sx={{ p: { xs: 3, md: 6 } }}>
              <Typography component="h1" variant="h3" color="inherit" gutterBottom sx={{ fontWeight: 'bold' }}>
                Premium Farming Supplies
              </Typography>
              <Typography variant="h5" color="inherit" paragraph sx={{ opacity: 0.9, mb: 4 }}>
                Discover high-quality seeds, tools, and equipment verified by experts.
                Start your season with the best.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                size="large"
                endIcon={<ArrowForward />}
                sx={{
                  borderRadius: 2,
                  px: 4,
                  py: 1.5,
                  fontSize: '1.1rem',
                  textTransform: 'none',
                  boxShadow: '0 4px 14px 0 rgba(0,0,0,0.3)'
                }}
              >
                Shop Now
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Paper>
  );
};

export default MarketplaceHero;
